import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerDbInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.kepler.db.url;
    const authService = inject(AuthService);

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        const headers: Record<string, string> = {
            Authorization: `Bearer ${authService.accessToken}`,
            'csdt-authorization-app': csdtAuthApp,
        };

        // Only add Content-Type if not FormData
        if (!(req.body instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }

        const clone = cloneAndAddHeaders(req, headers);
        console.debug('[Interceptors][KeplerDbInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
